// store/forms/samplingEventForm/filter/samplingEventWellsFiltersActions.js
// Shared filter actions factory for well-based tabs (Inspections, Wells/Sampling)

import { samplingEventWellsFiltersInitialState } from "./samplingEventWellsFiltersState";

/**
 * Factory to create filter actions for any tab that uses well filtering.
 * Operates on the nested `filters` property of the UI slice, which references
 * samplingEventWellsFiltersInitialState structure.
 *
 * @param {function} setUiFn - The setter function for this UI slice (e.g., api.setInspectionsUi)
 * @param {function} bump - The bump function to trigger re-renders
 * @returns {object} Filter actions object
 */
export const makeWellsFiltersActions = (setUiFn, bump) => ({
  // Toggle filter menu open/closed
  toggleFilterMenu: () => {
    setUiFn((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        isFilterMenuOpen: !prev.filters?.isFilterMenuOpen,
      },
    }));
    bump();
  },

  // Open filter menu
  openFilterMenu: () => {
    setUiFn((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        isFilterMenuOpen: true,
      },
    }));
    bump();
  },

  // Close filter menu
  closeFilterMenu: () => {
    setUiFn((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        isFilterMenuOpen: false,
      },
    }));
    bump();
  },

  // Apply partial filter updates (merges with existing filters)
  applyFilters: (filterPatch) => {
    setUiFn((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        filters: { ...prev.filters?.filters, ...filterPatch },
      },
    }));
    bump();
  },

  // Reset filters to defaults from initial state
  resetFilters: () => {
    setUiFn((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        filters: { ...samplingEventWellsFiltersInitialState.filters },
      },
    }));
    bump();
  },

  // Set sort options (merges with existing sort)
  setSort: (sortPatch) => {
    setUiFn((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        sort: { ...prev.filters?.sort, ...sortPatch },
      },
    }));
    bump();
  },

  // Reset sort to defaults from initial state
  resetSort: () => {
    setUiFn((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        sort: { ...samplingEventWellsFiltersInitialState.sort },
      },
    }));
    bump();
  },

  // Reset both filters and sort to defaults
  resetAll: () => {
    setUiFn((prev) => ({
      ...prev,
      filters: { ...samplingEventWellsFiltersInitialState },
    }));
    bump();
  },
});
